import React, { FC, useEffect, useState } from 'react';
import { snakeToCamel } from '../../caseUtils';
import {
  EnterpriseContextType,
  CustomWindow,
  EnterpriseExperiences,
} from './enterprise.types';
import { fetchEnterpriseDecisions } from '../enterprise.api';
import { flattenDomains } from '../../entity/expertises/entityExpertises.utils';

declare let window: CustomWindow;

export const EnterpriseContext = React.createContext<EnterpriseContextType>({
  enterpriseInfos: snakeToCamel(window.enterprise_info),
  experience: { decisionCount: 0, domains: [], juridictions: [], villes: [] },
});

export const EnterpriseProvider: FC = ({ children }) => {
  const [experience, setExperience] = useState<EnterpriseExperiences>({
    decisionCount: 0,
    domains: [],
    juridictions: [],
    villes: [],
  });

  useEffect(() => {
    async function load() {
      const {
        domains,
        juridictions,
        villes,
        decisionCount,
      } = await fetchEnterpriseDecisions(window.enterprise_info.siren);
      setExperience({
        domains: flattenDomains(domains),
        juridictions,
        villes,
        decisionCount,
      });
    }
    load();
  }, []);

  return (
    <EnterpriseContext.Provider
      value={{
        experience,
        enterpriseInfos: snakeToCamel(window.enterprise_info),
      }}
    >
      {children}
    </EnterpriseContext.Provider>
  );
};

export const withEnterprise = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const ComponentWithEnterprise: FC<Pick<
    P,
    Exclude<keyof P, keyof EnterpriseContextType>
  >> = props => (
    <EnterpriseContext.Consumer>
      {(enterprise: EnterpriseContextType) => (
        <Component {...(props as P)} {...enterprise} />
      )}
    </EnterpriseContext.Consumer>
  );
  return ComponentWithEnterprise;
};
